import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import VRFOutdoorDetail from '../../components/vrf/VRFOutdoorDetail';
import { defaultRejectHandler } from '../../utils/utility';
import { getVRFOutdoor, editVRFOutdoor } from '../../redux/vrf/vrf_outdoor_actions';

class VRFOutdoorEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isValid: false, isDirty: false, isSubmittable: false };
    this.detail = undefined;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.outdoor !== nextProps.outdoor && nextProps.show) {
      this.props.get(nextProps.outdoor.id);
    }
  }

  onSaveHandler() {
    const data = this.detail.getWrappedInstance().getWrappedInstance().getData();
    this.props.edit(this.props.outdoor.id, data);
  }

  render() {
    const { isEditing, errorMessage, detailObj, edit, get, outdoor, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal {...newProps} bsSize="large" aria-labelledby="contained-modal-title-lg" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>{t('edit vrf outdoor')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <VRFOutdoorDetail
            outdoor={detailObj}
            ref={ref => (this.detail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="vrf-outdoor-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.vrfOutdoor.errorMessage,
  isEditing: state.vrfOutdoor.isEditing,
  detailObj: props.outdoor && state.vrfOutdoor.objects[props.outdoor.id],
});

const mapDispatchToProps = dispatch => ({
  edit: (id, data) => defaultRejectHandler(dispatch(editVRFOutdoor(id, data))),
  get: id => defaultRejectHandler(dispatch(getVRFOutdoor(id))),
});

export default translate('translations')(
  connect(mapStateToProps, mapDispatchToProps)(VRFOutdoorEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/vrf/VRFOutdoorEditModal.js